'use client';

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type SiteLang = 'sr' | 'en';

interface SiteLanguageContextType {
    siteLang: SiteLang;
    setSiteLang: (lang: SiteLang) => void;
}

const SiteLanguageContext = createContext<SiteLanguageContextType | undefined>(undefined);

export function SiteLanguageProvider({ children }: { children: ReactNode }) {
    const [siteLang, setSiteLangState] = useState<SiteLang>('sr');

    useEffect(() => {
        const stored = localStorage.getItem('siteLang');
        if (stored === 'en' || stored === 'sr') {
            setSiteLangState(stored);
        }
    }, []);

    const setSiteLang = (lang: SiteLang) => {
        setSiteLangState(lang);
        localStorage.setItem('siteLang', lang);
    };

    return (
        <SiteLanguageContext.Provider value={{ siteLang, setSiteLang }}>
            {children}
        </SiteLanguageContext.Provider>
    );
}

export function useSiteLanguage() {
    const ctx = useContext(SiteLanguageContext);
    if (!ctx) throw new Error('useSiteLanguage must be used inside SiteLanguageProvider');
    return ctx;
}
